export default "__VITE_ASSET__49JkCSsy__"